import React, { useState } from 'react';
import {
  CurrentRevenueWidget,
  FleetWidget,
  OvereenkomstenWidget,
  AccountStatesWidget,
} from './AccountStatWidgets';
import TransactionsWidget from './TransactionsWidget';
import TopTracksWidget from './TopTracksWidget';
import EventLogsWidget from './EventLogsWidget';
import MostPlayedArtistsWidget from './MostPlayedArtistsWidget';
import { WidgetGrid } from './DashboardWidgets';
import DashboardSection from '../components/DashboardSection';
import './DashboardPage.css';

// DJB-127: borderless collapsible section shell (shared via
// components/DashboardSection since DJB-159/160).
// Stage-2 widgets (all on the DJB-139 templates), tweaked by DJB-148..152:
//   Sales Insights — Current Revenue (DJB-140/148), Transactions (DJB-142/194)
//   Users — Fleet (DJB-143/149), Overeenkomsten (DJB-144/150),
//           Account States (DJB-145/151)
//   Trends — Top 25 Tracks (DJB-147), Most Played Artists (DJB-154)
//   Event Logs — Recent Activity (DJB-152)
const SECTIONS = [
  { key: 'sales', title: 'Sales Insights' },
  { key: 'users', title: 'Users' },
  { key: 'trends', title: 'Trends' },
  { key: 'logs', title: 'Event Logs' },
];

const SECTION_CONTENT = {
  sales: (
    <WidgetGrid>
      <CurrentRevenueWidget />
      <TransactionsWidget />
    </WidgetGrid>
  ),
  users: (
    <WidgetGrid>
      <FleetWidget />
      <OvereenkomstenWidget />
      <AccountStatesWidget />
    </WidgetGrid>
  ),
  trends: (
    <WidgetGrid>
      <TopTracksWidget />
      <MostPlayedArtistsWidget />
    </WidgetGrid>
  ),
  logs: (
    <WidgetGrid>
      <EventLogsWidget />
    </WidgetGrid>
  ),
};

const DashboardPage = () => {
  // All sections start expanded; each collapses independently
  const [collapsedSections, setCollapsedSections] = useState(() => new Set());

  const toggleSection = (key) =>
    setCollapsedSections((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });

  return (
    <div className="dashboard-page">
      {SECTIONS.map(({ key, title }) => (
        <DashboardSection
          key={key}
          title={title}
          isOpen={!collapsedSections.has(key)}
          onToggle={() => toggleSection(key)}
          bodyId={`dashboard-section-body-${key}`}
        >
          {SECTION_CONTENT[key]}
        </DashboardSection>
      ))}
    </div>
  );
};

export default DashboardPage;
